import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import logo from "../assets/pss-code-tool-logo-transparent.png";
import faqImg from "../assets/faq.png";

const infoIcon = <FontAwesomeIcon icon={faInfoCircle} />;

function Header() {
  return (
    <>
      <header>
        <Link to="/">
          <img src={logo} className="logo" alt="PSS Code Tool Logo" />
        </Link>
        <ul className="docs">
          <li>
            <img src={faqImg} alt="FAQ" />
            <Link to="/faq">FAQ</Link>
          </li>
        </ul>
      </header>
      <div className="app-info">
        <Link to="/credits">{infoIcon}</Link>
      </div>
    </>
  );
}

export default Header;
